function Services () {
    return (
        <>
            <div className="row g-4">
                <div className="col-md-12">
                    <p className="lead text-muted text-center">Empowering businesses and individuals with robust digital solutions.</p>
                </div>
            </div>

            <div className="row g-4 mt-4">
                <div className="col-md-4">
                    <div className="card service-card p-4 text-center">
                        <h4 className="fw-bold">Frontend Development</h4>
                        <p className="text-muted">Beautiful, responsive, and user-friendly UI using modern frameworks like React and Bootstrap.</p>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card service-card p-4 text-center">
                        <h4 className="fw-bold">Backend Development</h4>
                        <p className="text-muted">Powerful backend using Laravel, Node.js, and secure APIs. Scalable and maintainable code architecture.</p>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card service-card p-4 text-center">
                        <h4 className="fw-bold">Customizations</h4>
                        <p className="text-muted">Modify existing features, tweak interfaces, or fine-tune the interface — all tailored to your needs.</p>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card service-card p-4 text-center">
                        <h4 className="fw-bold">Bug Fixing</h4>
                        <p className="text-muted">Squash bugs and improve performance in your existing systems — fast, reliable, and professional.</p>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card service-card p-4 text-center">
                        <h4 className="fw-bold">Teaching & Mentorship</h4>
                        <p className="text-muted">Learn to code from scratch or level up your skills. Personalized 1-on-1 mentorship in web development.</p>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card service-card p-4 text-center">
                        <h4 className="fw-bold">Website Migration</h4>
                        <p className="text-muted">Seamlessly transfer websites between hosting providers or platforms while ensuring data integrity, minimal downtime, and proper configuration.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Services;